import { hotpadsRequester, zillowRequester } from './requester';

const api = {
  listing: {
    fetchByAlias(params = {}) {
      return hotpadsRequester({
        method: 'get',
        endpoint: 'hotpads-api/api/v2/listing/byAliasV2',
        queryParams: params,
      });
    },
  },
  user: {
    ip(skipClientProxy) {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/datarouter/ipDetection',
        skipClientProxy: skipClientProxy,
      });
    },
    info(params) {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/api/v1/users/get',
        queryParams: params,
      });
    },
    submitFeedbackWithoutReport(body) {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v1/users/inquiryFeedback/submitFeedback',
        body,
      });
    },
    getFeedbackListings(body) {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v1/users/inquiryFeedback/getInquiredListings',
        body,
      });
    },
    reportUnavailableListings(body) {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v1/users/inquiryFeedback/reportListings',
        body,
      });
    },
  },
  // move-in-survey
  moveInFeedback: {
    submitFeedback(body) {
      return zillowRequester({
        method: 'post',
        endpoint: `renter-hub-api/api/v1/users/inquiryFeedback/submitLeaseDetails`,
        body,
      });
    },
    getListingsByRenterId(renterId, latestInquiredDateInMillis) {
      return zillowRequester({
        method: 'get',
        // TODO
        endpoint: `renter-hub-api/api/v1/users/inquiryFeedback/getListingsByRenterId`,
        queryParams: {
          renterId,
          latestInquiredDateInMillis,
        },
      });
    },
  },
  // autocomplete address
  address: {
    autocomplete(partialAddress) {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/api/v1/addresses/autocomplete',
        queryParams: {
          partialAddress,
        },
        timeout: 5000,
      });
    },
  },
  payments: {
    fetchPaymentInfo() {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v2/users/rentPayment/getRenterStatus',
        preparse: false,
      });
    },
  },
  waitlistConfirmation: {
    confirmWaitlist(leadId, hash, sendEmail) {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v1/waitlistConfirmation',
        queryParams: {
          leadId,
          hash,
          sendEmail,
        },
      });
    },
  },
  debug: {
    ipDetection() {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/datarouter/ipDetection',
      });
    },
    triggerException() {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/datarouter/errorGenerator',
      });
    },
  },
};

export default api;
